import React, { useState, useRef, useEffect } from "react";
import { sendMobileNumber } from "../../../service/userService";
import { charsNormalize } from "../../../util/charactorsNormalize";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

const LoginPage1 = ({setPage, mobileNumberRef, remainingTimeRef}) => {
    
    const regix = new RegExp(/^(0)?9\d{9}$/);
    const [phoneNumber, setPhoneNumber] = useState('');
	const [isLoading, setIsLoading] = useState(false);
	const [isValid, setIsValid] = useState(false);
	const textInputRef = useRef(null);

	useEffect(() => {
		textInputRef.current && textInputRef.current.focus();
	},[])

	const submitHandler = async (event) => {
		try {
			event.preventDefault();
			if (isValid) {
				if(phoneNumber.startsWith('9'))
				mobileNumberRef.current = '0' + phoneNumber;
				else
				mobileNumberRef.current = phoneNumber;
				setIsLoading(true);
				const { status, data } = await sendMobileNumber(mobileNumberRef.current);
		        if (status === 201) {
					remainingTimeRef.current = Math.floor(data.remainingSeconds);
					setPage('2');
		        }
		    }

		} catch (err) {
			toast.error(String(err));
		}
	}

	const getStatusOfInput = () => {
		if(isValid){
			return 'mb-1 form-control phone-number is-valid'
		}
		else{
			return 'mb-1 form-control phone-number is-invalid'
		}
							
	}
    return (
        <React.Fragment>
			<form onSubmit={submitHandler}>
				<div style={{ direction: "ltr", textAlign:'right' }} className="text-left">
					<label htmlFor="phoneNumber" className="text-dark mb-2">
						شماره موبایل
					</label>
					<div className="d-flex justify-content-center align-items-center">
						<span className="badge bg-success rounded-pill phone-number-code fs-6">+98</span>
						<input
							type="tel"
							className={getStatusOfInput()}
							id="phoneNumber"
							placeholder=""
							value={phoneNumber}
							ref={textInputRef}
							onChange={(e) => {
								if (regix.test(e.target.value)) {
									setIsValid(true);
								}
								else{
									setIsValid(false);
								}
								setPhoneNumber(charsNormalize(e.target.value));
							}}
							onBlur={() => {
								if (phoneNumber !== '') {
								}
							}}
						/>
					</div>
				</div>
				<section className="card-body pt-0 mt-2">
					<p className="privacy-info">
						<Link onClick={() => setPage('4')}>حریم خصوصی</Link> البرز مارکت را میپذیرم.
					</p>
					<div className="text-center mt-4">
						<button
							type="submit"
							className="btn btn-success mx-auto d-flex align-items-center justify-content-center"
							disabled={isLoading || !isValid}
							>
								{
									isLoading &&
									<i  className= 'spinner-border spinner-border-sm operator-button me-2'
									></i>
								}
								دریافت کد تایید
						</button>
					</div>
				</section>
			</form>
        </React.Fragment>
    );
};

export default LoginPage1;
